import { Route, Routes } from "react-router";
import { EnterCode } from "../views/enter-code/EnterCode.tsx";
import { PageNotFound } from "../views/page-not-found/PageNotFound.tsx";
import { Reader } from "../views/reader/Reader.tsx";
import { Layout } from "./Layout.tsx";

export function Router() {
	return (
		<Routes>
			<Route path="/" element={<Layout />}>
				<Route index element={<EnterCode />} />

				<Route path="*" element={<PageNotFound />} />
			</Route>
			<Route path=":code" element={<Reader />} />
			<Route path="ongeldige-code" element={<PageNotFound />} />
		</Routes>
	);
}
